import {
  Component,
  ViewChild,
  EventEmitter,
  Output,
  HostListener,
} from '@angular/core';
// import { ChatInterfaceComponent } from '../chat-interface/chat-interface.component';
import { ThemeService } from '../../services/theme.service';
import { TranslationService } from '../../services/translation.service';
import type { ToolbarTranslations } from '../../i18n/toolbar';
import en from '../../i18n/en/toolbar';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css'],
})
export class ToolbarComponent {
  @Output() openChat = new EventEmitter<number | null>();
  // @ViewChild(ChatInterfaceComponent, { static: true })
  // chatInterfaceComponent!: ChatInterfaceComponent;

  @Output() toggleGraph = new EventEmitter<void>();
  @Output() searchApplications = new EventEmitter<string>();

  searchActive = false;
  searchQuery = '';
  lastScrollTop = 0;
  toolbarVisible = true;

  showConversationModal = false;
  toolbarApplicationId: number | null = null;

  translations: ToolbarTranslations = en as ToolbarTranslations;

  get t(): ToolbarTranslations {
    return this.translations;
  }

  constructor(
    public themeService: ThemeService,
    private translationService: TranslationService
  ) {
    const current = this.translationService.getToolbarTranslations();
    if (current) {
      this.translations = current;
    }
    this.translationService.onChange(() => {
      const next = this.translationService.getToolbarTranslations();
      if (next) {
        this.translations = next;
      }
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > this.lastScrollTop) {
      // Downscroll
      this.toolbarVisible = false;
    } else {
      // Upscroll
      this.toolbarVisible = true;
    }
    this.lastScrollTop = st <= 0 ? 0 : st;
  }

  onToggleGraph(): void {
    this.toggleGraph.emit();
  }

  toggleSearch(): void {
    this.searchActive = !this.searchActive;
    if (!this.searchActive) {
      this.searchQuery = '';
      this.searchApplications.emit(this.searchQuery);
    }
  }

  onSearchChange(event: any): void {
    this.searchQuery = event.target.value;
    this.searchApplications.emit(this.searchQuery);
  }

  // Helper to globally clean up Bootstrap modal backdrops and modal-open class
  cleanupBootstrapBackdrops(): void {
    document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
    document.body.classList.remove('modal-open');
  }

  addNewApplication(): void {
    // Emit event to parent to open chat modal for a new application (null or custom logic)
    this.openChat.emit(null);
    console.log('Toolbar: addNewApplication() - openChat emitted');
  }
  onChatClose(): void {
    this.showConversationModal = false;
    this.toolbarApplicationId = null;
    this.cleanupBootstrapBackdrops();
  }
  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  triggerChat(applicationId: number) {
    this.openChat.emit(applicationId);
  }
}
